import { render, staticRenderFns } from "./WrittenQuestion.vue?vue&type=template&id=04e6dd58&scoped=true&"
import script from "./WrittenQuestion.vue?vue&type=script&lang=js&"
export * from "./WrittenQuestion.vue?vue&type=script&lang=js&"
import style0 from "./WrittenQuestion.vue?vue&type=style&index=0&id=04e6dd58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6dd58",
  null
  
)

component.options.__file = "WrittenQuestion.vue"
export default component.exports